import {
    ADD_AD_ATTACHMENT, ADD_TOBA_FORM_ATTACHMENT, CHANGE_AD_FORM_DATA, CHANGE_AD_FORM_SETTINGS,
    REMOVE_AD_FORM_ATTACHMENT,
    REMOVE_TOBA_FORM_ATTACHMENT
} from "./index";

//action that changed the form data
export function changeAdFormData(key, value) {
    return {
        type: CHANGE_AD_FORM_DATA,
        payload: {
            key,
            value
        }
    }
}

//action that changes the ad store settings
export function changeAdFormSettings(key, value) {
    return {
        type: CHANGE_AD_FORM_SETTINGS,
        payload: {
            key,
            value
        }
    }
}


//action that adds an attachment for the ad
export function addAdAttachment(payload) {
    return {
        type: ADD_AD_ATTACHMENT,
        payload: payload
    }
}

//action that removes an attachment from the ad form
export function removeAdFormAttachment(payload) {
    return {
        type: REMOVE_AD_FORM_ATTACHMENT,
        payload: payload
    }
}